module.exports = new __parcel__URL__("watermelon.199e013c.svg").toString();